import media from './media';
import myCars from './myCars';
import widgetInfo from './widgetInfo';
import modalSettings from './modalSettings';
import renderSettings from './renderSettings';
import isBeingDragged from './isBeingDragged';

const root = {
	media,
	myCars,
	widgetInfo,
	modalSettings,
	renderSettings,
	isBeingDragged
};

export default root;
